var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-button"},[_c('Button',{attrs:{"type":_vm.info.form.formType,"size":_vm.size,"icon":_vm.info.form.icon}},[_vm._v(" "+_vm._s(_vm.info.form.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }